/* tslint:disable */

declare var Object: any;
export interface PaymentMethodsInterface {
  "payment_method_name": string;
  "has_ref_no": boolean;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  "payment_method"?: number;
}

export class PaymentMethods implements PaymentMethodsInterface {
  "payment_method_name": string;
  "has_ref_no": boolean;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  "payment_method": number;
  constructor(data?: PaymentMethodsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PaymentMethods`.
   */
  public static getModelName() {
    return "PaymentMethods";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PaymentMethods for dynamic purposes.
  **/
  public static factory(data: PaymentMethodsInterface): PaymentMethods{
    return new PaymentMethods(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PaymentMethods',
      plural: 'PaymentMethods',
      path: 'PaymentMethods',
      idName: 'id',
      properties: {
        "payment_method_name": {
          name: 'payment_method_name',
          type: 'string'
        },
        "has_ref_no": {
          name: 'has_ref_no',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
        "payment_method": {
          name: 'payment_method',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
